import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';
import FormStyles from 'styles/mixins/Form.styles';

const StyledSourceAddDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: clamp(0px, ${props => props.theme.layout(884)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(884)}, 86vw);
  }
  
  .InlineForm {
    .Form-section {
      margin-top: ${props => props.theme.layout('-1.5sp')};
      margin-bottom: ${props => props.theme.layout('-0.75sp')};
    }
    
    .FormControl {
      &.FormField-name-filterType {
        row-gap: ${props => props.theme.layout('1sp')};

        > .InputLabel, > .FormLabel {
          margin-top: ${props => props.theme.layout(5)} !important;
          min-width: ${props => props.theme.layout(86)};
        }
        
        .List {
          flex-wrap: wrap;
          width: fit-content;
          .ListItem {
            white-space: nowrap;
          }
        }
      }
    }
  }

  ${FormStyles}
  ${ComponentStyles}
`;

StyledSourceAddDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledSourceAddDialog;
